import { action } from 'satcheljs';
import { ForgottenAttachmentsPluginViewState } from '../store/schema/ForgottenAttachmentsPluginViewState';

export const setHasAttachmentTriggerWords = action(
    'SET_HAS_ATTACHMENT_TRIGGER_WORDs',
    (pluginViewState: ForgottenAttachmentsPluginViewState, hasTriggerWords: boolean) => ({
        pluginViewState,
        hasTriggerWords,
    })
);

export const setAttachmentKeywordsDetectedBeforeUserInput = action(
    'SET_ATTACHMENT_KEYWORDS_DETECTED_BEFORE_USER_INPUT',
    (pluginViewState: ForgottenAttachmentsPluginViewState, count: number | null) => ({
        pluginViewState,
        count,
    })
);
